// API Configuration - Single source of truth for backend URLs
// Uses VITE_API_BASE_URL environment variable set in Netlify

const STAGING_FRONTEND_HOST = 'traffic-lite-front-end-staging.netlify.app';
const STAGING_API_BASE = 'https://traffic-lite-sandbox-production.up.railway.app/api';
const PROD_API_BASE = 'https://traffic-lite-production.up.railway.app/api';

const host = typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : '';
const isStagingFrontendHost = host === STAGING_FRONTEND_HOST;

const rawConfiguredBaseUrl = import.meta.env.VITE_API_BASE_URL;
let API_BASE_URL = rawConfiguredBaseUrl;

// Staging hard-stop: never allow staging web app to point at production backend.
if (isStagingFrontendHost) {
  const pointsToProdApi = typeof API_BASE_URL === 'string'
    && API_BASE_URL.includes('traffic-lite-production.up.railway.app');
  if (!API_BASE_URL || pointsToProdApi) {
    console.warn('⚠️ Overriding VITE_API_BASE_URL for staging host to prevent production auth leakage.', {
      previousValue: API_BASE_URL || null,
      forcedValue: STAGING_API_BASE
    });
    API_BASE_URL = STAGING_API_BASE;
  }
}

if (!API_BASE_URL && host) {
  const isProdFrontendHost =
    host.includes('trafficliteedu.com')
    || host.includes('traffic-lite-production.netlify.app')
    || host.includes('traffic-lite-production.up.railway.app');
  API_BASE_URL = isProdFrontendHost ? PROD_API_BASE : STAGING_API_BASE;
}

// Validate that API_BASE_URL is set
if (!API_BASE_URL) {
  const errorMessage = '❌ VITE_API_BASE_URL is not set! Please configure this environment variable in Netlify.\n' +
    'Expected format: https://<your-backend-domain>/api';
  throw new Error(errorMessage);
}

// Log the API base URL on startup for debugging
console.log('🌐 API_BASE_URL configured:', API_BASE_URL);
console.log('🌐 Full env check:', {
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  allEnvVars: Object.keys(import.meta.env).filter(k => k.startsWith('VITE_'))
});

// Export base URL without /api suffix (some calls need the base, some need /api)
export const API_BASE_URL_FULL = API_BASE_URL;
export const API_BASE_URL_WITH_API = API_BASE_URL.endsWith('/api') 
  ? API_BASE_URL 
  : `${API_BASE_URL}/api`;

// For Socket.IO and other base URL needs
export const SOCKET_URL = API_BASE_URL;

export default {
  API_BASE_URL: API_BASE_URL_WITH_API,
  API_BASE_URL_FULL,
  SOCKET_URL
};

